import { UPDATE_AVG_PRICE_WIDGET } from "./actionTypes"

export const updateAvgPriceWidget = data => {
  return {
    type: UPDATE_AVG_PRICE_WIDGET,
    payload: data,
  }
}
